import QtdModulo from '../../ModulosCrefito/QtdModulo'
import Epi from '../../ModulosCrefito/Modulos/Epi'
import ParametrosAssistenciais from '../../ModulosCrefito/Modulos/ParametrosAssistenciais'
import RegistroProntuario from '../../ModulosCrefito/Modulos/RegistroProntuario'
import OutrosDados from '../../ModulosCrefito/Modulos/OutrosDados'
import OrientacoesNotificacao from '../../ModulosCrefito/Modulos/OrientacoesNotificacao'
import CapsPsicossocial from '../../ModulosCrefito/Modulos/CapsPsicossocial'
import ResponsavelFisc from '../../ModulosCrefito/Modulos/ResponsavelFisc'
import ProfissionaisNoEstabelecimento from '../../ModulosCrefito/Modulos/ProfissionaisNoEstabelecimento'
import ServicoNaUnidade from '../../ModulosCrefito/Modulos/ServicoNaUnidade'
import Estagio from '../../ModulosCrefito/Modulos/Estagio'
import RecursoEstrutura from '../../ModulosCrefito/Modulos/RecursoEstrutura'
import SituacoesNaFiscalizacao from '../../ModulosCrefito/Modulos/SituacoesNaFiscalizacao'
import Terceirizados from '../../ModulosCrefito/Modulos/Terceirizados'
import Fiscalizadores from '../../ModulosCrefito/Modulos/Fiscalizadores'
import React from 'react'

const Caps = () => {
    return (
        <>
            <Fiscalizadores modulo="fiscalizadores" />
            <QtdModulo texto="SERVIÇOS TERCEIRIZADOS" modulo="terceirizados" />
            <Terceirizados modulo="terceirizados" />
            <QtdModulo texto="CENTRO DE ATENÇÃO PSICOSSOCIAL" modulo="psicossocial" />
            <CapsPsicossocial modulo="psicossocial" />
            <QtdModulo texto="RESPONSÁVEL PELO RECEBIMENTO DA FISCALIZAÇÃO" modulo="responsavelfisc" />
            <ResponsavelFisc modulo="responsavelfisc" />
            <QtdModulo texto="FISIOTERAPEUTAS QUE TRABALHAM NO ESTABELECIMENTO" modulo="profissionais" />
            <ProfissionaisNoEstabelecimento modulo="profissionais" />
            <QtdModulo texto="PARÂMETROS ASSISTENCIAIS" modulo="parametros" />
            <ParametrosAssistenciais modulo="parametros" />
            <QtdModulo texto="REGISTRO EM PRONTUÁRIO" modulo="prontuario" />
            <RegistroProntuario modulo="prontuario" />
            <QtdModulo texto="SERVIÇO NA UNIDADE" modulo="servico" />
            <ServicoNaUnidade modulo="servico" />
            <QtdModulo texto="ESTÁGIO" modulo="estagios" />
            <Estagio modulo="estagios" />
            <QtdModulo texto="RECURSOS/ESTRUTURA FÍSICA" modulo="recursoestrutura" />
            <RecursoEstrutura modulo="recursoestrutura" />
            <QtdModulo texto="SITUAÇÕES CONSTATADAS DURANTE A FISCALIZAÇÃO" modulo="situacoes" />
            <SituacoesNaFiscalizacao modulo="situacoes" />
            <QtdModulo texto="EQUIPAMENTO DE PROTEÇÃO INDIVIDUAL" modulo="epi" />
            <Epi modulo="epi" />
            <QtdModulo texto="OUTROS DADOS DA FISCALIZAÇÃO" modulo="outrosDados" />
            <OutrosDados modulo="outrosDados" />
            <QtdModulo texto="ORIENTAÇÕES/NOTIFICAÇÕES" modulo="orientacoes" />
            <OrientacoesNotificacao modulo="orientacoes" />
        </>
    )
}

export default Caps